export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/0c7f90dcab4574f291a5b93f31621815.svg";